import React from "react";
import "../styles/Projects.css";

const Projects = () => {
  return (
    <div id="projects" className="content-holder">
      <h2>Projects</h2>

      <a
        target="_blank"
        href="https://dailymuck.com/"
        className="content-holder-experience"
      >
        <div className="content-holder-experience__right-firm-year">
          <h3>The Daily Muck</h3>
        </div>
        <p>
          For this project, I was responsible for the complete frontend and
          backend development, following a pre-designed layout in Figma. The
          website was built using WordPress and is dedicated to a news agency
          with a strong focus on political content.
        </p>
        <div className="content-holder-experience__right-tech">
          <span>HTML</span>
          <span>CSS</span>
          <span>JavaScript</span>
          <span>PHP</span>
          <span>Figma</span>
        </div>
        <p className="notes">
          This project was designed and developed within the B22 agency.
        </p>
      </a>

      <a
        target="_blank"
        href="https://b22.io/"
        className="content-holder-experience"
      >
        <div className="content-holder-experience__right-firm-year">
          <h3>Bureau TwentyTwo</h3>
        </div>
        <p>
          This project was executed as a redesign of the website for the Bureau
          Twentytwo agency. I handled all aspects of the project, including
          frontend, backend, responsiveness, SEO, and robots.txt.
        </p>
        <div className="content-holder-experience__right-tech">
          <span>HTML</span>
          <span>CSS</span>
          <span>JavaScript</span>
          <span>PHP</span>
          <span>SEO</span>
        </div>
        <p className="notes">
          This project was designed and developed within the B22 agency.
        </p>
      </a>

      <a
        target="_blank"
        href="https://pbndesign.com/"
        className="content-holder-experience"
      >
        <div className="content-holder-experience__right-firm-year">
          <h3>Plant By Number</h3>
        </div>
        <p>
          On this project, I implemented the complete frontend based on the
          design created in Figma. I also worked on the responsiveness and made
          some minor changes to the backend.
        </p>
        <div className="content-holder-experience__right-tech">
          <span>HTML</span>
          <span>CSS</span>
          <span>JavaScript</span>
          <span>PHP</span>
        </div>
        <p className="notes">
          This project was designed and developed within the B22 agency.
        </p>
      </a>
      <a
        target="_blank"
        href="https://3ap.ch/"
        className="content-holder-experience"
      >
        <div className="content-holder-experience__right-firm-year">
          <h3>3ap</h3>
        </div>
        <p>
          The website was developed based on the client's design, where I
          handled the entire site, including the frontend, animations,
          responsiveness, and backend. It was implemented in two languages,
          English and German.
        </p>
        <div className="content-holder-experience__right-tech">
          <span>HTML</span>
          <span>CSS</span>
          <span>JavaScript</span>
          <span>PHP</span>
        </div>
        <p className="notes">
          This project was designed and developed within the B22 agency.
        </p>
      </a>

      <a
        target="_blank"
        href="https://luchat8.com/"
        className="content-holder-experience"
      >
        <div className="content-holder-experience__right-firm-year">
          <h3>Lucha T8</h3>
        </div>
        <p>
          On this project, I worked on the complete frontend according to the
          design created in Figma, focusing on the site's responsiveness and
          adding multiple languages.
        </p>
        <div className="content-holder-experience__right-tech">
          <span>HTML</span>
          <span>CSS</span>
          <span>JavaScript</span>
        </div>
        <p className="notes">
          This project was designed and developed within the B22 agency.
        </p>
      </a>

      <a
        target="_blank"
        href="https://www.execassistance.com/"
        className="content-holder-experience"
      >
        <div className="content-holder-experience__right-firm-year">
          <h3>Executive Assistants</h3>
        </div>
        <p>
          On this project, I was responsible for the entire frontend,
          implementing all visual elements and interactive animations. I also
          ensured that the site was fully responsive, providing users with an
          optimal experience across various devices.
        </p>
        <div className="content-holder-experience__right-tech">
          <span>HTML</span>
          <span>CSS</span>
          <span>JavaScript</span>
        </div>
        <p className="notes">
          This project was designed and developed within the B22 agency.
        </p>
      </a>

      <a
        target="_blank"
        href="https://seawall-point.com/"
        className="content-holder-experience"
      >
        <div className="content-holder-experience__right-firm-year">
          <h3>Seawall Point</h3>
        </div>
        <p>
          In this project, I was in charge of the complete frontend, where I
          developed all visual components and interactive animations.
          Additionally, I focused on optimizing the site’s responsiveness to
          ensure users had an excellent experience across various devices.
        </p>
        <div className="content-holder-experience__right-tech">
          <span>HTML</span>
          <span>CSS</span>
          <span>JavaScript</span>
        </div>
        <p className="notes">
          This project was designed and developed within the B22 agency.
        </p>
      </a>
    </div>
  );
};

export default Projects;
